const config = {
  debug: false,
  logLevelConsole: "INFO",
  logLevelRemote: "INFO",
  timeout: 4000,
  defaultLocale: "en_CH",
};

export const { debug } = config;
export const { logLevelConsole } = config;
export const { logLevelRemote } = config;
export const { timeout } = config;
export const { defaultLocale } = config;
